import classNames from 'classnames';
import React, { useContext } from 'react';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import WidgetPhotosGridRegularProps from './widget-photos-grid-regular.props';

import './widget-photos-grid-regular.scss';
import Icon from 'atomic/icon';

const WidgetPhotosGridRegular: React.FC<WidgetPhotosGridRegularProps> = ({ data }) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    return (
        <div className="w-photos-grid-regular">
            <div className="w-photos-grid-regular__list">
                {data.map(item => (
                    <a
                        target={item.target}
                        key={item.url}
                        href={item.url}
                        className={classNames({
                            'w-photos-grid-regular__list__item': true,
                            'w-photos-grid-regular__list__item--desktop': api.getDevice() === 'desktop'
                        })}
                    >
                        <picture>
                            <img src={item.img} alt={item.title}/>
                        </picture>
                        <div className="title-box">
                            <p className="title-box__title">
                                {item.title}
                                {api.getDevice() === 'desktop' && (
                                    <>
                                        {' '}
                                        <Icon name="chevron-right" size={16}/>
                                    </>
                                )}

                            </p>
                        </div>
                    </a>
                ))}
            </div>
        </div>
    );
};

export default WidgetPhotosGridRegular;
